import React from 'react';
import '../styles/Contact.css';

function Contact() {
  return (
    <section id="contact" className="contact section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Have questions? We're here to help. Reach out to our team and we'll get back to you as
            soon as possible.
          </p>
        </div>

        {/* Contact Grid */}
        <div className="contact-grid">
          {/* Contact Information */}
          <div className="contact-info">
            <h3 className="contact-info-title">Contact Information</h3>

            {/* Address */}
            <div className="contact-item">
              <div className="contact-icon">📍</div>
              <div className="contact-details">
                <h4>Office Address</h4>
                <p>
                  806, Lokmanya Tilak Road
                  <br />
                  Near Borivali West Station
                  <br />
                  Borivali West, Mumbai
                  <br />
                  Maharashtra 400092, India
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="contact-item">
              <div className="contact-icon">✉️</div>
              <div className="contact-details">
                <h4>Email Support</h4>
                <p>
                  <a href="mailto:support@fortif.app">support@fortif.app</a>
                </p>
                <p className="contact-note">
                  We typically respond within 24 hours
                </p>
              </div>
            </div>

            {/* Support Hours */}
            <div className="contact-item">
              <div className="contact-icon">🕒</div>
              <div className="contact-details">
                <h4>Support Hours</h4>
                <p>
                  Monday - Friday: 9:00 AM - 6:00 PM IST
                  <br />
                  Saturday: 10:00 AM - 4:00 PM IST
                  <br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form / Map Placeholder */}
          <div className="contact-visual">
            <div className="contact-card">
              <h3 className="card-title">Quick Contact</h3>
              <p className="card-description">
                For immediate assistance, email us at{' '}
                <a href="mailto:support@fortif.app" className="text-primary">
                  support@fortif.app
                </a>{' '}
                or use the contact details provided.
              </p>

              <div className="contact-features">
                <div className="feature-badge">
                  <span className="badge-icon">⚡</span>
                  <span>24-hour response time</span>
                </div>
                <div className="feature-badge">
                  <span className="badge-icon">🔒</span>
                  <span>Secure communication</span>
                </div>
                <div className="feature-badge">
                  <span className="badge-icon">🌍</span>
                  <span>Global support</span>
                </div>
              </div>

              {/* Location Map Placeholder */}
              <div className="map-placeholder">
                <div className="map-icon">🗺️</div>
                <p>Borivali West, Mumbai</p>
                <p className="map-note">Near Borivali West Railway Station</p>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Contact Options */}
        <div className="contact-cta">
          <h3>Looking for Sales or Partnerships?</h3>
          <p>
            For enterprise inquiries, custom solutions, or partnership opportunities, contact our
            sales team.
          </p>
          <a href="mailto:sales@fortif.app" className="btn btn-primary btn-large">
            Contact Sales
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
